export function removeTrailingZeros(number: string | number): string {
  //remove multiple zeros before the number. Example: '000.012' to '0.012' or '001.52' to '1.52'
  const removedZerosBeforeDecimal = number.toString().replace(/^0+(?!\.)/, '');

  //replace zeros after decimal separator. Example: '1.100' to '1.1' or '1.010' to '1.01'
  const formattedNumber = removedZerosBeforeDecimal.replace(/\.0*$|(\.\d*[1-9])0+$/, '$1');

  return formattedNumber;
}
